export function getLastWorkdayOfDate(date: Date | number | string) {
    const dateCopy = new Date(date);

    if (dateCopy.getDay() === 0) {
        dateCopy.setDate(dateCopy.getDate() - 2);
    } else if (dateCopy.getDay() === 6) {
        dateCopy.setDate(dateCopy.getDate() - 1);
    }

    return dateCopy;
}
